import { RootState } from "../../../../redux/store";
import { useSelector } from "react-redux";
import { Grid, Stack, Typography } from "@mui/material";
import { CustomChip } from "../../../global/chips/CustomChip";

export const ListingEquipments = () => {
  const theme = useSelector((state: RootState) => state.theme);
  const equipments = useSelector(
    (state: RootState) => state.trainingPlan.listingEquipments,
  );

  return (
    <Stack
      className="pb-[24px] space-y-[24px]"
      sx={{
        borderBottom: 1,
        borderColor: theme.componentColors.surface.surfContainerHighest,
      }}
    >
      <Typography
        variant="h2"
        sx={{
          color: theme.componentColors.surface.onSurface,
        }}
        className="text-[22px] font-medium"
      >
        Equipment
      </Typography>
      <Grid container spacing={1}>
        {equipments?.map((item, i) => {
          return (
            <Grid key={i} item>
              <CustomChip label={item.title} />
            </Grid>
          );
        })}
      </Grid>
    </Stack>
  );
};
